import React, { Component } from 'react';
import { withRouter }       from 'react-router';
import { connect }          from 'react-redux';
import { Table }            from 'react-bootstrap';
import PubSub               from 'pubsub-js';
import { ClipLoader }       from 'react-spinners';
import ListDelete           from './ListDelete';
import ListAdd              from './ListAdd';
import { PubSubConstants }  from '../environment';
import { listFetchData }    from '../../../../actions/pubsub/list';

var apiHost = PubSubConstants.WebApiHost;

class List extends Component {
  
  subscriber(msg, data){
    this.props.fetchData(apiHost);
  }
    
  componentDidMount() {
    this.props.fetchData(apiHost);
    this.token = PubSub.subscribe('pubsub.list.reload', this.subscriber.bind(this));
  }
  
  componentWillUnmount(){
    PubSub.unsubscribe(this.token);
  }

  render() {
    let content = null;
    var items = [];
    for (var i = 0; i < this.props.list.length; i++) {
      var item = this.props.list[i];
      items.push(                 
        <ListDelete item={item} key={i} />
      );
    }
    
    if (this.props.isLoading) {
      content =
        <div style={{ marginRight: 'auto', marginLeft: 'auto', width: '5em' }}>
          <ClipLoader
            color={'#072659'} 
            loading={this.props.isLoading} 
          />
        </div>
    }
    else {
      content = 
        <div>
          <Table responsive bordered>
            <thead>
              <tr>
                <th>Process</th>
                <th>Event</th>
                <th>Owner</th>
                <th>Disable</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {items}
            </tbody>
          </Table>
          <ListAdd />
        </div>;
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    list: state.pubsub.list.list,
    hasErrored: state.pubsub.list.listHasErrored,
    isLoading: state.pubsub.list.listIsLoading
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchData: (host) => dispatch(listFetchData(host))
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(List));
